import updateSubOrder from '../../../../../Services/updateSubOrder'

export default (guid, field, value) => (dispatch) => {

  dispatch(updateSubOrder(guid, field, value))

}
